export default function MyDashboard() {
  myDashboardInit();
};

const DASHBOARD_WELCOME_STORAGE = "my-dashboard-hide-welcome";

function myDashboardInit() {
  const button = document.querySelector(".my-dashboard__block-button-close");
  const welcome = document.querySelector(".js-my-dashboard__welcome-block");

  if (welcome && !sessionStorage.getItem(DASHBOARD_WELCOME_STORAGE)) {
    welcome.style.display = 'flex';
  }

  const handleClick = () => {
    if (welcome) {
      sessionStorage.setItem(DASHBOARD_WELCOME_STORAGE, true);
      welcome.style.display = 'none';
    }
  }

  if (button) {
    button.addEventListener("click", handleClick);
  }
}
